import React, { createContext, useContext, useState, useCallback } from 'react';

interface QuoteModalContextType {
  isOpen: boolean;
  prefillProduct: string;
  openModal: (productModel?: string) => void;
  closeModal: () => void;
}

const QuoteModalContext = createContext<QuoteModalContextType | undefined>(undefined);

export const QuoteModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [prefillProduct, setPrefillProduct] = useState('');

  const openModal = useCallback((productModel?: string) => {
    if (productModel) {
      setPrefillProduct(productModel);
    }
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setPrefillProduct('');
  }, []);

  return (
    <QuoteModalContext.Provider value={{ isOpen, prefillProduct, openModal, closeModal }}>
      {children}
    </QuoteModalContext.Provider>
  );
};

export const useQuoteModal = (): QuoteModalContextType => {
  const context = useContext(QuoteModalContext);
  if (context === undefined) {
    throw new Error('useQuoteModal must be used within a QuoteModalProvider');
  }
  return context;
};

export default QuoteModalContext;
